module.exports = __webpack_public_path__ + "media/images/articles/interview/img01-bc134abbb8c4d5ccfcf5a99b84e5067c.png";